import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FeatureToggle} from './feature-toggle';
import {Observable, ReplaySubject} from 'rxjs';
import {environment} from '../../../environments/environment';
import {map, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService {

  private readonly enabledFeatures$ = new ReplaySubject<FeatureToggle[]>();

  constructor(private readonly httpClient: HttpClient) {
  }

  getEnabledFeatures = (): Observable<FeatureToggle[]> => {
    const url = `${environment.baseUrl}${environment.featureToggleURI}`;
    return this.httpClient.get<FeatureToggle[]>(url).pipe(
      tap(res => {
        if (res) {
          this.enabledFeatures$.next(res);
        }
      }),
    );
  }

  isFeatureEnabled$ = (feature: FeatureToggle): Observable<boolean> => this.enabledFeatures$.pipe(
    map(enabledFeatures => enabledFeatures.includes(feature))
  )
}
